"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Save = void 0;
var _Favorite = _interopRequireDefault(require("@tvg/fuse-icons/lib/Favorite"));
var _FavoriteFilled = _interopRequireDefault(require("@tvg/fuse-icons/lib/FavoriteFilled"));
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _config = require("./config");
var _styledSave = require("./styled-save");
var _excluded = ["clickCallback", "dataTestId", "saveLabel", "savedLabel", "showLabel", "isSaved", "iconSize"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback,
  useState = _react["default"].useState,
  useEffect = _react["default"].useEffect;
var propTypes = {
  clickCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  saveLabel: _propTypes["default"].string,
  savedLabel: _propTypes["default"].string,
  showLabel: _propTypes["default"].bool,
  isSaved: _propTypes["default"].bool,
  iconSize: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_config.componentConfig.icon.sizes), _propTypes["default"].shape(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(function (acc, current) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, _propTypes["default"].oneOf(_config.componentConfig.icon.sizes)));
  }, {}))])
};
var defaultProps = {
  clickCallback: null,
  dataTestId: null,
  saveLabel: null,
  savedLabel: null,
  showLabel: true,
  isSaved: false,
  iconSize: _config.componentConfig.icon.sizes[1] // medium
};
var Save = exports.Save = forwardRef(function (_ref, ref) {
  var clickCallback = _ref.clickCallback,
    dataTestId = _ref.dataTestId,
    saveLabel = _ref.saveLabel,
    savedLabel = _ref.savedLabel,
    showLabel = _ref.showLabel,
    isSaved = _ref.isSaved,
    iconSize = _ref.iconSize,
    others = _objectWithoutProperties(_ref, _excluded);
  // Component config
  var icon = _config.componentConfig.icon,
    label = _config.componentConfig.label;
  // States
  var _useState = useState(isSaved),
    _useState2 = _slicedToArray(_useState, 2),
    saved = _useState2[0],
    setSaved = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    messageSR = _useState6[0],
    setMessageSR = _useState6[1];
  // Set default label and srLabel texts based on saved state
  var saveLabelText = !saved && (saveLabel || 'Save for later');
  var savedLabelText = saved && (savedLabel || 'Saved');
  var labelText = saved ? savedLabelText : saveLabelText;
  // Set srLabel to labelText only when showLabel === false
  var srLabel = !showLabel ? labelText : '';
  var savedIconClassName = saved && icon.savedIconClassName;

  // Event handlers
  var saveClickHandler = useCallback(function (e) {
    // Run callback
    if (typeof clickCallback === 'function') clickCallback(e, ref, !saved);
    // Toggle between save / saved states
    setSaved(function (toggle) {
      return !toggle;
    });
  }, [saved, clickCallback]);
  var focusHandler = useCallback(function () {
    return setFocused(true);
  }, []);
  var blurHandler = useCallback(function () {
    return setFocused(false);
  }, []);
  useEffect(function () {
    if (focused) {
      setMessageSR(labelText);
    }
  }, [labelText]);
  useEffect(function () {
    if (!focused) {
      setMessageSR('');
    }
  }, [focused]);
  useEffect(function () {
    setSaved(isSaved);
  }, [isSaved]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styledSave.StyledSave, _extends({
    "data-testid": dataTestId,
    onClick: saveClickHandler,
    "aria-pressed": saved,
    ref: ref,
    onFocus: focusHandler,
    onBlur: blurHandler
  }, others), /*#__PURE__*/_react["default"].createElement(_iconElement.Icon, {
    icon: saved ? /*#__PURE__*/_react["default"].createElement(_FavoriteFilled["default"], null) : /*#__PURE__*/_react["default"].createElement(_Favorite["default"], null),
    className: savedIconClassName,
    color: saved ? 'var(--color-brand-mid)' : 'var(--color-global-black)',
    responsiveSize: iconSize,
    srLabel: srLabel
  }), showLabel && /*#__PURE__*/_react["default"].createElement(_styledSave.StyledSaveLabel, {
    color: label.color,
    size: label.size,
    tag: label.tag,
    type: label.type
  }, labelText)), focused && /*#__PURE__*/_react["default"].createElement(_fuseUtils.SrOnly, {
    "aria-live": "polite"
  }, messageSR));
});
Save.propTypes = propTypes;
Save.defaultProps = defaultProps;
var _default = exports["default"] = Save;